/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  Typography,
  TimePicker,
  message,
  DatePicker,
  Calendar,

} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import Moment from 'moment';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { TIME_FORMAT } from 'utils/normalizers';
import { getSemana } from 'api/catalogos/index';
import { integerRegExp } from 'utils/patterns';
import {
  getJornadasDetalleHorario,
  postJornadaDetalleHorario,
  deleteJornadadetalleHorario,
  patchJornadaDetalleHorario,
  getJornadaDetalleHorario,
  putFechasJornadaDetalle,
} from 'api/catalogos/JornadaDetalleHorario';
import { checkToken } from 'api/utils';

// Este debe estar fuera del componente principal
import { CloseOutlined } from '@ant-design/icons';

export const jornadadetalleHorarioPermission = {
  permissionModel: 'jornadadetallehorario',
  hasAllViewPermissions: true,
};

const { RangePicker } = DatePicker; // Importar ícono de cierre

const MultipleDateCalendar = ({ form }) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [calendarValue, setCalendarValue] = useState(null); // Estado para controlar el mes visible

  const handleSelect = (date) => {
    const dateStr = date.format('YYYY-MM-DD');

    // Solo selecciona si el usuario hace clic en el mismo mes
    if (!calendarValue || calendarValue.month() === date.month()) {
      const exists = selectedDates.includes(dateStr);
      const updated = exists
        ? selectedDates.filter((d) => d !== dateStr)
        : [...selectedDates, dateStr];

      setSelectedDates(updated);
      form.setFieldValue('fechas', updated);
    }

    // Siempre actualiza el mes visible
    setCalendarValue(date);
  };

  const cellRender = (current, info) => {
    if (info.type === 'date') {
      const dateStr = current.format('YYYY-MM-DD');
      const isSelected = selectedDates.includes(dateStr);

      return (
        <div
          style={{
            backgroundColor: isSelected ? '#1890ff' : undefined,
            color: isSelected ? 'white' : undefined,
            borderRadius: isSelected ? '50%' : undefined,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {current.date()}
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: 4 }}>
      <Calendar
        fullscreen={false}
        value={calendarValue}
        onSelect={handleSelect}
        cellRender={cellRender}
      />
      <div style={{ marginTop: 8 }}>
        <strong>Fechas seleccionadas:</strong>
        <ul>
          {selectedDates.map((d) => (
            <li key={d}>{d}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const JornadaDetalleHorario = ({ permission, JornadaDetalle, aplicaVigencia }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [dias, setDias] = useState([]);

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getJornadasDetalleHorario({ jornada_detalle: JornadaDetalle });
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
        _dias,
      ] = await Promise.all([

        getJornadasDetalleHorario({ jornada_detalle: JornadaDetalle }),
        getSemana(),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setLoading(false);
        setDias(_dias);
      }
    };
    if (JornadaDetalle) {
      fetchAll();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [JornadaDetalle]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formDatos.resetFields();
  };
  const onClickDeactivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: false,
      };
      const saved = await patchJornadaDetalleHorario(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const onClickActivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: true,
      };
      const saved = await patchJornadaDetalleHorario(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _jornada = await getJornadaDetalleHorario(match.id);
    if (_jornada) {
      form.setFieldsValue({
        ...formatReceived(_jornada),
        de_las: new
        Moment(_jornada.de_las, 'HH:mm:ss'),
        a_las: new
        Moment(_jornada.a_las, 'HH:mm:ss'),
      });
      formDatos.setFieldsValue(formatReceived(_jornada));
      setVisible(true);
      formatReceived(_jornada);
    }
    setLoading(false);
  };
  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();

      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };

      values.jornada_detalle = JornadaDetalle;
      values.a_las = values.a_las.format('HH:mm:ss');
      values.de_las = values.de_las.format('HH:mm:ss');

      if (aplicaVigencia) {
        const fechasSeleccionadas = values.fechas || [];

        if (!fechasSeleccionadas.length) {
          message.error('Seleccione al menos una fecha');
          setLoading(false);
          return;
        }

        // Crear payload con formato { fecha: 'YYYY-MM-DD' }
        const payloadFechas = fechasSeleccionadas.map((fecha) => ({ fecha }));

        // Llamar a la API secundaria usando horario en la URL
        const result = await putFechasJornadaDetalle(
          JornadaDetalle,
          values.de_las,
          values.a_las,
          payloadFechas,
        );

        if (result) {
          onCancel();
          await fetchData();
        }

        setLoading(false);
        return;
      }

      // Si NO aplica vigencia, usar la lógica clásica
      const diasExistentes = data
        .filter((item) => !selectedRowKeys.length || item.id !== selectedRowKeys[0])
        .flatMap((item) => item.dias || []);

      const diasSeleccionados = values.dias || [];
      const diasDuplicados = diasSeleccionados.filter((dia) => diasExistentes.includes(dia));

      if (diasDuplicados.length > 0) {
        const nombresDuplicados = dias
          .filter((d) => diasDuplicados.includes(d.id))
          .map((d) => d.nombre)
          .join(', ');
        message.error(`Los siguientes días ya han sido registrados: ${nombresDuplicados}`);
        setLoading(false);
        return;
      }

      values.dias = diasSeleccionados;

      const [key] = selectedRowKeys;
      const saved = await (key
        ? patchJornadaDetalleHorario(key, values)
        : postJornadaDetalleHorario(values));

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteJornadadetalleHorario(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    ...(aplicaVigencia
      ? [
        {
          titleText: 'Fecha',
          dataIndex: 'fecha',
          key: 'fecha',
          render: (val) => (val ? Moment(val).format('YYYY-MM-DD') : 'Sin fecha'),
          width: 150,
        },
      ]
      : []),
    {
      titleText: 'Día',
      dataIndex: 'dias',
      key: 'dias',
      render: (val) => (Array.isArray(val) && val.length ? val.map((id) => dias.find((e) => e.id === id)?.nombre).join(', ') : 'Sin días'
      ),
      width: 150,
    },

    {
      titleText: ' Hora Inicial ',
      dataIndex: 'de_las',
      key: 'de_las',
      render: (val) => (val ? val?.format(TIME_FORMAT) : 'N/A'),
      width: 150,
    },
    {
      titleText: ' Hora Final',
      dataIndex: 'a_las',
      key: 'a_las',
      render: (val) => (val ? val?.format(TIME_FORMAT) : 'N/A'),

      width: 150,
    },
    {
      titleText: 'Número De Horas',
      dataIndex: 'descripcion_no_de_horas',
      key: 'descripcion_no_de_horas',

      width: 150,
    },

  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
    horas: [
      requiredRule,
      {
        pattern: integerRegExp,
        validator: async () => {
          const { horas_en_jornada } = form.getFieldsValue();
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(horas_en_jornada)) {
            throw new Error('Ingrese un valor válido');
          }
          if (horas_en_jornada > 24) {
            throw new Error('No se puede exceder el número de horas de un día');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={data}
          cols={columns}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
            onClickActivate,
            onClickDeactivate,
          }}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
            // width="80%"
            // bodyStyle={{ height: '80vh', overflowY: 'auto' }}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Jornada Detalle Horario`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
                                  )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            name="general"
            onFinish={() => onFinish()}
            scrollToFirstError
            autoComplete="off"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  label={aplicaVigencia ? 'Fechas específicas' : 'Día'}
                  name={aplicaVigencia ? 'fechas' : 'dias'}
                  hasFeedback
                  rules={[{ required: true, message: 'Este campo es requerido' }]}
                >
                  {aplicaVigencia ? (
                    <MultipleDateCalendar form={form} />
                  ) : (
                    <Select
                      mode="multiple"
                      labelProp="nombre"
                      keyProp="id"
                      dataSource={dias}
                      allowClear
                      placeholder="Seleccione un día"
                    />
                  )}
                </Form.Item>
              </Col>
              <Row gutter={[10, 10]}>
                <Col xs={24}>
                  <Typography.Text strong>* Horario del Día</Typography.Text>
                </Col>
                <Col xs={10} sm={10}>
                  <Form.Item
                    name="de_las"
                    label="Hora Inicial"
                    rules={rules.required}
                    hasFeedback
                  >
                    <TimePicker format="hh:mm A" use24Hours style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={10} sm={10}>
                  <Form.Item
                    name="a_las"
                    label="Hora Final"
                    rules={rules.required}
                    hasFeedback
                  >
                    <TimePicker format="hh:mm A" use24Hours style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>

              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="descripcion_no_de_horas"
                  label="Número De Número de Horas por Día"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>

              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>

            </Row>

          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`el Día ${dias.find((e) => e.id === form.getFieldValue('dia'))?.nombre || ''}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default JornadaDetalleHorario;
